/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export * from "./IComponentDefRegistry";
export * from "./IBlueprintTemplatesRegistry";
export * from "./IDataSourceDefRegistry";
export * from "./IFunctionDefRegistry";
export * from "./IHTMLResourceRegistry";
export * from "./IIconPackRegistry";
export * from "./IIntegrationDefRegistry";
export * from "./ISecretsProviderRegistry";
export * from "./ISessionStorageRegistry";
export * from "./IRoutesRegistry";
export * from "./IRegistryRegistry";
export * from "./IComponentDefRegistry";
export * from "./IAuthProviderRegistry";

export * from "./IResourceRegistry";
export * from "./IResolversRegistry";
export * from "./IResourceRegistry";
export * from "./IComponentsRegistry";

export * from "./ComponentsRegistry";
export * from "./RegistriesRegistry";
